module.exports = __webpack_public_path__ + "img/no-class-time.d8096a53.gif";